{
  "name": "client-ui",
  "version": "5.0.0",
  "overrides": {
    "@babel/core": "7.29.7",
    "@lingui/core": "4.14.1",
    "@datorama/akita": {
      "tslib": "^2.8.1"
    },
    "eslint-config-airbnb-base": {
      "eslint": "^10.5.0"
    },
    "ngx-bootstrap": {
      "@angular/common": "^22.0.0",
      "@angular/core": "^22.0.0",
      "@angular/forms": "^22.0.0"
    },
    "ngx-mask": {
      "@angular/common": "^22.0.0",
      "@angular/core": "^22.0.0",
      "@angular/forms": "^22.0.0"
    }
  },
  "scripts": {
    "prepare": "git config --get core.hooksPath >/dev/null 2>&1 && echo 'Skipping lefthook install: core.hooksPath is set' || lefthook install",
    "build": "ng build",
    "_deploy-example": "git pull && npm ci && npm run deploy --env=d4",
    "deploy": "echo \"deploying clux to $npm_config_env\" && npm run build -- --configuration=$npm_config_env && aws s3 rm s3://${npm_config_env}-uba-client-ui --recursive && aws s3 cp ./dist/browser s3://${npm_config_env}-uba-client-ui --recursive",
    "deploy:host": "echo \"deploying pux to $npm_config_env\" && npm run build -- --configuration=$npm_config_env && aws s3 rm s3://${npm_config_env}-uba-client-ui --recursive --profie=hosting && aws s3 cp ./dist/browser s3://${npm_config_env}-uba-client-ui --recursive --profie=hosting",
    "bundle-report": "npm run build -- --configuration=p1 --stats-json && webpack-bundle-analyzer dist/stats-es2015.json",
    "coverage-report": "open coverage/lcov-report/index.html",
    "lint": "ng lint",
    "lint:fix": "ng lint --fix",
    "lint:tsc": "npm run lint && npx tsc -p src/tsconfig.app.json --noEmit && npx tsc -p src/tsconfig.spec.json --noEmit",
    "security": "npm audit --audit-level=critical",
    "sonar-quality-gate": "build/aws/sonar-quality-gate.sh",
    "sonar-scanner": "node_modules/sonar-scanner/bin/sonar-scanner",
    "_start-example": "npm run start -- --configuration=d3",
    "start": "ng serve --ssl --ssl-key certificate/localhost/localhost.key --ssl-cert certificate/localhost/localhost.crt",
    "start:ie": "ng serve --configuration=es5 --ssl --ssl-key certificate/key.pem --ssl-cert certificate/cert.pem",
    "start:d1": "ng serve --configuration=d1 --ssl --ssl-key certificate/localhost/localhost.key --ssl-cert certificate/localhost/localhost.crt",
    "start:d2": "ng serve --configuration=d2 --ssl --ssl-key certificate/localhost/localhost.key --ssl-cert certificate/localhost/localhost.crt",
    "start:d3": "ng serve --configuration=d3 --ssl --ssl-key certificate/localhost/localhost.key --ssl-cert certificate/localhost/localhost.crt",
    "start:d4": "ng serve --configuration=d4 --ssl --ssl-key certificate/localhost/localhost.key --ssl-cert certificate/localhost/localhost.crt",
    "start:d5": "ng serve --configuration=d5 --ssl --ssl-key certificate/localhost/localhost.key --ssl-cert certificate/localhost/localhost.crt",
    "start:d6": "ng serve --configuration=d6 --ssl --ssl-key certificate/localhost/localhost.key --ssl-cert certificate/localhost/localhost.crt",
    "start:d7": "ng serve --configuration=d7 --ssl --ssl-key certificate/localhost/localhost.key --ssl-cert certificate/localhost/localhost.crt",
    "start:d8": "ng serve --configuration=d8 --ssl --ssl-key certificate/localhost/localhost.key --ssl-cert certificate/localhost/localhost.crt",
    "start:d9": "ng serve --configuration=d9 --ssl --ssl-key certificate/localhost/localhost.key --ssl-cert certificate/localhost/localhost.crt",
    "start:o1": "ng serve --configuration=o1 --ssl --ssl-key certificate/localhost/localhost.key --ssl-cert certificate/localhost/localhost.crt",
    "start:t2": "ng serve --configuration=t2 --ssl --ssl-key certificate/localhost/localhost.key --ssl-cert certificate/localhost/localhost.crt",
    "start:t3": "ng serve --configuration=t3 --ssl --ssl-key certificate/localhost/localhost.key --ssl-cert certificate/localhost/localhost.crt",
    "start:t5": "ng serve --configuration=t5 --ssl --ssl-key certificate/localhost/localhost.key --ssl-cert certificate/localhost/localhost.crt",
    "start:s1": "ng serve --configuration=s1 --ssl --ssl-key certificate/localhost/localhost.key --ssl-cert certificate/localhost/localhost.crt",
    "cy:lint": "eslint -c ./cypress/.eslintrc ./cypress/ --ext .ts,.js",
    "cy:run": "./node_modules/.bin/cypress run",
    "cy:open": "./node_modules/.bin/cypress open",
    "cy:all": "./node_modules/.bin/cypress run -- --headless",
    "cy:tags": "node ./cypress/autoregression-testrails/tags.js",
    "cy:testrail": "node cypress/autoregression-testrails/testrail-runner.js",
    "cy:ci-parallel-start": "START_SERVER_AND_TEST_INSECURE=1 start-server-and-test start:uitest https-get://localhost:4000/ 'npm run cy:ci-parallel'",
    "cy:ci-parallel": "cypress run --browser $BROWSER --record --key=$DASHBOARD_KEY --parallel --ci-build-id $CODEBUILD_BUILD_BATCH_NUMBER --no-runner-ui --auto-cancel-after-failures false",
    "cy": "./node_modules/.bin/cypress run",
    "cy:headless": "./node_modules/.bin/cypress run --headless",
    "start:uitest": "ng serve --configuration=test --watch=false --live-reload=false --ssl --ssl-key certificate/key.pem --ssl-cert certificate/cert.pem",
    "test": "npm run test:unit",
    "test:unit": "jest --config jest.config.js --silent",
    "test:unit:no-coverage": "jest --config jest.config.js --collectCoverage false --silent",
    "test:unit:loud": "jest --config jest.config.js --collectCoverage false",
    "test:tags": "node ./autoregression-testrails/tags.js",
    "test:testrail": "node ./autoregression-testrails/testrail-runner.js",
    "uitest": "START_SERVER_AND_TEST_INSECURE=1 start-server-and-test start:uitest https-get://localhost:4000 uitest:headless",
    "uitest:headless": "npx -n=--max_old_space_size=6144 cypress run",
    "uitest:visible": "npx -n=--max_old_space_size=6144 cypress run --headed",
    "update-models": "ts-node --skip-project src/app/shared/models/uba/update-models.ts"
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "^22.0.2",
    "@angular/cdk": "^22.0.2",
    "@angular/common": "^22.0.2",
    "@angular/compiler": "^22.0.2",
    "@angular/core": "^22.0.2",
    "@angular/forms": "^22.0.2",
    "@angular/localize": "^22.0.2",
    "@angular/material": "^22.0.2",
    "@angular/platform-browser": "^22.0.2",
    "@angular/platform-browser-dynamic": "^22.0.2",
    "@angular/router": "^22.0.2",
    "@brycemarshall/string-format": "^1.0.2",
    "@contentful/rich-text-html-renderer": "^14.1.2",
    "@contentful/rich-text-plain-text-renderer": "^17.2.1",
    "@contentful/rich-text-types": "^14.1.2",
    "@datorama/akita": "^8.0.1",
    "@formatjs/intl-datetimeformat": "^7.4.9",
    "@formatjs/intl-getcanonicallocales": "^3.2.10",
    "@ng-bootstrap/ng-bootstrap": "^21.0.0",
    "@popperjs/core": "^2.11.8",
    "@tasc/bam-config": "^0.4.29",
    "aws-amplify": "^6.18.0",
    "bootstrap": "^4.6.2",
    "bowser": "^2.14.1",
    "contentful": "^8.5.8",
    "core-js": "^3.49.0",
    "dayjs": "^1.11.21",
    "file-saver": "^2.0.5",
    "lodash": "^4.18.1",
    "ngx-bootstrap": "^21.2.1",
    "ngx-mask": "^21.0.1",
    "ngx-mat-select-search": "^8.0.6",
    "ngx-pagination": "^6.0.3",
    "number-to-words": "^1.2.4",
    "raygun4js": "^2.25.7",
    "regenerator-runtime": "^0.14.1",
    "rxjs": "^7.8.2",
    "tslib": "^2.8.1",
    "uuid": "^14.0.1",
    "whatwg-fetch": "^3.6.20",
    "zone.js": "^0.16.2"
  },
  "devDependencies": {
    "@angular-devkit/build-angular": "^22.0.4",
    "@angular-eslint/builder": "^22.0.0",
    "@angular-eslint/eslint-plugin": "^22.0.0",
    "@angular-eslint/eslint-plugin-template": "^22.0.0",
    "@angular-eslint/schematics": "^22.0.0",
    "@angular-eslint/template-parser": "^22.0.0",
    "@angular/cli": "^22.0.4",
    "@angular/compiler-cli": "^22.0.2",
    "@angular/language-service": "^22.0.2",
    "@eslint/js": "^10.0.1",
    "@stylistic/eslint-plugin": "^5.10.0",
    "@tasc/test-fixtures": "1.4.279-release-5-16.1",
    "@types/d3": "^7.4.3",
    "@types/file-saver": "^2.0.7",
    "@types/jest": "^30.0.0",
    "@types/jsonwebtoken": "^9.0.10",
    "@types/lodash": "^4.17.24",
    "@types/mocha": "^10.0.10",
    "@types/node": "^26.0.0",
    "@types/number-to-words": "^1.2.3",
    "@types/raygun4js": "^2.13.8",
    "@typescript-eslint/eslint-plugin": "^8.62.0",
    "@typescript-eslint/parser": "^8.62.0",
    "angular-eslint": "^22.0.0",
    "axe-core": "^4.12.1",
    "cli-table3": "^0.6.5",
    "cross-env": "^10.1.0",
    "cypress": "^15.18.0",
    "cypress-axe": "^1.7.0",
    "cypress-file-upload": "^5.0.8",
    "eslint": "^10.5.0",
    "eslint-config-airbnb-base": "^15.0.0",
    "eslint-plugin-import": "^2.32.0",
    "eslint-plugin-rxjs-x": "^1.0.2",
    "flush-promises": "^1.0.2",
    "jest": "^30.4.2",
    "jest-environment-jsdom": "^30.4.1",
    "jest-preset-angular": "^17.0.0",
    "jest-sonar-reporter": "^2.0.0",
    "jsonwebtoken": "^9.0.3",
    "lefthook": "^2.1.9",
    "ng-mocks": "^14.15.3",
    "rimraf": "^6.1.3",
    "sonar-scanner": "^3.1.0",
    "start-server-and-test": "^3.0.11",
    "ts-jest": "^29.4.11",
    "ts-mockito": "^2.6.1",
    "ts-node": "^10.9.2",
    "typescript": "6.0.3",
    "typescript-eslint": "^8.62.0",
    "webpack-bundle-analyzer": "^5.3.0"
  },
  "engines": {
    "node": ">=24.0.0",
    "npm": ">=11.0.0"
  },
  "prettier": {
    "singleQuote": true,
    "trailingComma": "es5",
    "printWidth": 250
  }
}
